import { useCallback } from 'react';
import {
    EmailDomainGetStatusResult,
    EmailDomainParameters,
    EmailDomainSetEmailParameters,
    EmailDomainVerificationResult,
    EnterpriseParameters,
    Unit,
} from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { useAPI } from '@mews/framework';
import { createFetchAction, useCommanderThunkDispatch } from '@mews-commander/utils';
import prefix from '@mews-commander/legacy-entities/src/prefix';

const EMAIL_DOMAINS_GET_STATUS_FETCH = prefix('EMAIL_DOMAINS_GET_STATUS_FETCH');
const EMAIL_DOMAINS_SET_EMAIL_FETCH = prefix('EMAIL_DOMAINS_SET_EMAIL_FETCH');
const EMAIL_DOMAINS_VERIFY_FETCH = prefix('EMAIL_DOMAINS_VERIFY_FETCH');
const EMAIL_DOMAINS_DELETE_FETCH = prefix('EMAIL_DOMAINS_DELETE_FETCH');

type FetchStatusParams = Pick<EnterpriseParameters, 'enterpriseId'>;
const fetchStatus =
    (params: FetchStatusParams): CommanderThunkAction<AsyncAction<EmailDomainGetStatusResult>> =>
    async (dispatch, _getState, { repositories }) =>
        dispatch(createFetchAction(EMAIL_DOMAINS_GET_STATUS_FETCH, repositories.emailDomains.getStatus(params)));

export const useEmailDomainStatus = ({ enterpriseId }: FetchStatusParams) => {
    const dispatch = useCommanderThunkDispatch();
    const fetchData = useCallback(async () => dispatch(fetchStatus({ enterpriseId })), [dispatch, enterpriseId]);
    return useAPI(fetchData, undefined);
};

type SetEmailParams = Pick<EmailDomainSetEmailParameters, 'enterpriseId' | 'email'>;
export const setEmail =
    (params: SetEmailParams): CommanderThunkAction<AsyncAction> =>
    async (dispatch, _getState, { repositories }) =>
        dispatch(createFetchAction(EMAIL_DOMAINS_SET_EMAIL_FETCH, repositories.emailDomains.setEmail(params)));

type VerifyDnsSettingsParams = Pick<EmailDomainParameters, 'enterpriseId' | 'sendGridDomainId'>;
export const verifyDnsSettings =
    (params: VerifyDnsSettingsParams): CommanderThunkAction<AsyncAction<EmailDomainVerificationResult>> =>
    async (dispatch, _getState, { repositories }) =>
        dispatch(createFetchAction(EMAIL_DOMAINS_VERIFY_FETCH, repositories.emailDomains.verify(params)));

type DeleteDnsSettingsParams = Pick<EmailDomainParameters, 'enterpriseId' | 'sendGridDomainId'>;
export const deleteDnsSettings =
    (params: DeleteDnsSettingsParams): CommanderThunkAction<AsyncAction<Unit>> =>
    async (dispatch, _getState, { repositories }) =>
        dispatch(createFetchAction(EMAIL_DOMAINS_DELETE_FETCH, repositories.emailDomains.delete(params)));
